import React, { useEffect, useState } from "react"
import { Plus } from "@styled-icons/boxicons-regular"
import { useBreakpoint, Breakpoints } from "gatsby-plugin-breakpoints"

import { Element, Text } from "legacy/components/shared/base"
import FooterLink from "./FooterLink"
import Icon from "legacy/components/shared/Icon"
import { Maybe } from "types/Maybe"
import {
  PrismicFooterDataBodyNavColumn,
  PrismicFooterDataBodyNavColumnItemType,
} from "types/__generated__/gatsby-graphql"
import { useTheme } from "src/legacy/utils"

interface OwnProps {
  list: Maybe<PrismicFooterDataBodyNavColumn>
}

type LinkListProps = OwnProps

const LinkList: React.FC<LinkListProps> = ({
  list,
}): React.ReactElement | null => {
  if (!list) return null

  const [isOpen, setIsOpen] = useState(true)
  const breakpoints = useBreakpoint()
  const { colors } = useTheme()
  const headline = list.primary?.headline?.text
  const links = list.items ? list.items : null
  const maxHeight = isOpen ? "400px" : "0"
  const iconTransform = isOpen ? "rotate(225deg)" : "rotate(0)"

  const handleClick = (
    breakpoints: Breakpoints,
    currentState: boolean
  ): void => {
    if (breakpoints.sm) {
      setIsOpen(!currentState)
    }
  }

  useEffect(() => {
    if (breakpoints.sm) {
      setIsOpen(false)
    } else {
      setIsOpen(true)
    }
  }, [breakpoints.sm, breakpoints.md, breakpoints.lg, breakpoints.xl])

  return (
    <Element width={["auto", `${(1 / 3) * 100}%`]}>
      <Text
        alignItems="center"
        display="flex"
        cursor={["pointer", "pointer", "default"]}
        fontSize={["17", "17", "text.footerHeader"]}
        lineHeight={["22px", "22px", "normal"]}
        justifyContent="space-between"
        mb={["0", "20"]}
        onClick={() => {
          handleClick(breakpoints, isOpen)
        }}
        variant="footerHeader"
      >
        {headline}
        <Icon
          display={["inline", "none"]}
          iconColor={colors.white}
          iconHoverColor="inherit"
          size="16px"
          style={{ transform: iconTransform }}
          transition="all 0.3s ease"
        >
          <Plus />
        </Icon>
      </Text>
      <Element
        as="ul"
        maxHeight={[maxHeight, maxHeight, "auto"]}
        mb={["10", "10", "0"]}
        mt={["10", "10", "20"]}
        overflow="hidden"
        pr="50px"
        transition="all 0.3s ease"
      >
        {links?.map(
          (
            link: Maybe<PrismicFooterDataBodyNavColumnItemType>,
            index: number
          ) => {
            return <FooterLink key={`link_${index}`} link={link} />
          }
        )}
      </Element>
    </Element>
  )
}

export default LinkList
